import EnquiriesLinesModal from '../../../../components/Sales/Enquiries/Lines/EnquiriesLinesModal'
import List from '../../../../components/Sales/Enquiries/Lines/List'
import React, { Fragment } from 'react'

function EnquiriesLines(props) {
  return (
    <Fragment>
      <EnquiriesLinesModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

export default EnquiriesLines
